export default __webpack_public_path__ + "static/media/payment@2x.9100290f.png";